export const PERIMETER_LIMIT = 750
export const PERIMETER_LIMIT_FOR_DOCUMENTS = 20
export const SIDE_MESSAGE_LIMIT = 255
export const REACT_APP_CNIL_RGPD_URL =
  'https://www.cnil.fr/fr/transferts-de-donnees-hors-ue-ce-qui-change-avec-le-reglement-general-sur-la-protection-des-donnees'
export const ORGANIZATION_TYPE = 'internal'
export const ORGANIZATION_APPLICATION =
  '/applications/d0336464-b693-4e89-93f0-3f060b876eee'
export const EXTERNAL_DEVIS_URL =
  'https://www.suez.com/fr/devis-dechets-entreprises?sourcetype=ece'
export const EXTERNAL_IT4US_URL =
  'https://it4usprod.service-now.com/suez_service_portal?id=sc_cat_item&sys_id=d66cf5e41b048050dac2a9b7bd4bcb78'
export const LOAD_MORE_LIMIT = 10
